<div class="background"></div>
<ion-icon class="logo" src="/assets/icon/logo-white.svg" aria-hidden="true"></ion-icon>
<h4>{{ title() }}</h4>
@if (description()) {
  <div>{{ description() }}</div>
}
<ion-spinner name="bubbles" class="loader" [attr.aria-label]="'Common.Loading' | translate"></ion-spinner>
